import gql from 'graphql-tag';
import { reportDefinition, reportDefinitionList } from './reports.queries';

export const GET_ORGANIZATION_CUSTOM_REPORTS_QUERY = gql`
  query getOrganizationCustomReports(
    $organizationRevvUid: String
    $page: Int
    $limit: Int
    $dateRangeStart: String
    $dateRangeEnd: String
    $report_type: String
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        report_definitions(
          filters: {
            page: $page
            limit: $limit
            dateRangeStart: $dateRangeStart
            dateRangeEnd: $dateRangeEnd
            reportType: $report_type
          }
        ) {
          current_page
          page_count
          total_count
          results {
            ...ReportDefinitionList
          }
        }
      }
    }
  }
  ${reportDefinitionList}
`;

export const GET_ORGANIZATION_CUSTOM_REPORT_QUERY = gql`
  query getOrganizationCustomReports($revv_uid: String!, $organizationRevvUid: String!) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        report_definitions(filters: { revvUid: $revv_uid }) {
          results {
            ...ReportDefinition
          }
        }
      }
    }
  }
  ${reportDefinition}
`;

export const GET_ORGANIZATION_PAYOUT_REPORT_QUERY = gql`
  query getOrganizationCustomReports($organizationRevvUid: String!) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        payout_report {
          ...ReportDefinition
        }
      }
    }
  }
  ${reportDefinition}
`;

export const GET_ORGANIZATION_REPORT_CONDITIONS = gql`
  query getOrganizationReportDefinitionConditions(
    $organizationRevvUid: String
    $reportType: String
    $page: Int
    $limit: Int
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        report_definition_conditions(filters: { reportType: $reportType, page: $page, limit: $limit }) {
          report_key
          attributes {
            value
            name
            value_options {
              name
              value
            }
            predicates {
              name
              value
            }
            data_type
          }
        }
      }
    }
  }
`;

export const GET_ORGANIZATION_REPORT_COLUMNS = gql`
  query getOrganizationReportDefinitionColumns(
    $organizationRevvUid: String
    $columnOptions: ColumsOptionsEnum
    $reportType: String
    $page: Int
    $limit: Int
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        report_definition_columns(
          filters: { reportType: $reportType, columnOptions: $columnOptions, page: $page, limit: $limit }
        ) {
          name
          value
        }
      }
    }
  }
`;

export const UPDATE_ORGANIZATION_REPORT_MUTATION = gql`
  mutation updateOrganizationReportDefinitionMutation($report: UpdateReportDefinitionInput!) {
    organizationUpdateReportDefinition(reportDefinition: $report) {
      errors
      reportDefinition {
        ...ReportDefinition
      }
    }
  }
  ${reportDefinition}
`;

export const RUN_ORGANIZATION_REPORT_MUTATION = gql`
  mutation organizationRunReportDefinition($attributes: ReportDefinitionRunInput!) {
    organizationRunReportDefinition(reportAttributes: $attributes) {
      message
    }
  }
`;

export const CANCEL_ORGANIZATION_REPORT_MUTATION = gql`
  mutation organizationCancelReportDefinition($attributes: ReportDefinitionRunInput!) {
    organizationCancelReportDefinition(reportAttributes: $attributes) {
      message
    }
  }
`;

export const DELETE_ORGANIZATION_REPORT_MUTATION = gql`
  mutation organizationDeleteReportDefinition($attributes: ReportDefinitionRunInput!) {
    organizationDeleteReportDefinition(reportAttributes: $attributes) {
      message
    }
  }
`;

export const CREATE_ORGANIZATION_REPORT_MUTATION = gql`
  mutation organizationCreateReportDefinition($reportDefinition: CreateReportDefinitionInput!) {
    organizationCreateReportDefinition(reportDefinition: $reportDefinition) {
      reportDefinition {
        revv_uid
      }
      errors
    }
  }
`;

export const GET_ORGANIZATION_REPORT_INTEGRATIONS = gql`
  query getOrganizationIntegrations(
    $organizationRevvUid: String
    $page: Int
    $limit: Int
    $revvUid: String
    $active: Boolean
    $type: IntegrationTypeEnum
    $source: [IntegrationSourceTypeEnum!]!
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        active_integration_types
        existing_integration_types
        integrations(
          filters: { page: $page, limit: $limit, revvUid: $revvUid, active: $active, type: $type, source: $source }
        ) {
          current_page
          page_count
          total_count
          results {
            id
            active
            type
            s3Fields {
              bucket
            }
            ftpFields {
              ftpAddress
              ftpPath
            }
          }
        }
      }
    }
  }
`;
